<div class="sign-up-complete-container">
  <div class="content">
    <kion-sign-up-shop
      *ngIf="titles$ | async as titles"
      [isoCode]="isoCode"
      [titleOptions]="titles"
      [firstName]="firstName"
      [lastName]="lastName"
      [email]="email"
      (addressChanged)="addressChanged($event)"
    ></kion-sign-up-shop>
    <div class="checks">
      <div class="spacer"></div>
      <div class="checkboxes">
        <kion-checkbox
          [boxes]="checkboxes"
          (requiredSelected)="requiredCheckboxesSet($event)"
        ></kion-checkbox>
      </div>
    </div>
    <div class="actions">
      <kion-button [title]="'signUp.button.cancel' | translate" mode="discreet" (clicked)="cancel()"></kion-button>
      <kion-button [title]="'signUp.button.continue' | translate" mode="primary" (clicked)="register()" [disabled]="!(address$ | async) || !(checkboxesSet$ | async)"></kion-button>
    </div>
  </div>
</div>
